import { AmigoButton, AmigoContent, AmigoImage, AmigoSection, AmigoTextBlock, AmigoTitle } from './Amigo.styles';
import amigoBannerSideImage from '../../../assets/amigo-banner-side.png';

export default function AmigoBanner() {
    return (
        <AmigoSection>
            <AmigoContent>
                <AmigoTextBlock>
                    <AmigoTitle>amigo, móvel 100 GB só por €5/mês é aqui</AmigoTitle>
                    <AmigoButton
                        onClick={() => (window.location.href = 'https://www.oteuamigo.pt')}
                        aria-label="Saber mais sobre os pacotes Amigo"
                    >
                        Aderir
                    </AmigoButton>
                </AmigoTextBlock>
                <AmigoImage
                    src={amigoBannerSideImage}
                    alt="Banner promocional Amigo"
                />
            </AmigoContent>
        </AmigoSection>
    );
}
